<script setup>
import {reactive, watch} from "vue";
import DatePicker from "@/components/form/DatePicker.vue";

const props = defineProps({
    filterId: {type: String, required: true},
    label: {type: String, required: true},
    modelValue: {type: Object, default: () => ({from: null, to: null})},
});

const emit = defineEmits(["update:modelValue"]);


const range = reactive({from: props.modelValue.from, to: props.modelValue.to});

watch(range, (val) => {
    emit("update:modelValue", {...val});
}, {deep: true});

const clear = () => {
    range.from = null;
    range.to = null;
};

defineExpose({clear});
</script>

<template>
    <div>
        <b-field :label="label" custom-class="mb-3">
            <DatePicker
                :id="`${filterId}_from`"
                v-model="range.from"
                :placeholder="$t('filters.from')"
                />
        </b-field>
        <b-field custom-class="mb-3">
            <DatePicker
                :id="`${filterId}_to`"
                v-model="range.to"
                :placeholder="$t('filters.to')"
                />
        </b-field>
    </div>
</template>
